import { defineComponent as _defineComponent } from 'vue'
import { getJumpInfoFromRemoteConfig } from '@/business/wallet-area/jump';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { getUrlParamByKey, UrlParamKey } from '@/utils/url-params-helper';
import { CustomException } from '@tencent/ppd-base-libs';
import { hideLoading, showLoading } from '@tencent/wphk-act-base-ui';
import { to } from '@tencent/wphk-base-utils';
import { jumpPage } from '@tencent/wphk-components-jump-page';
import { MultiJumpContainer, MultiJumpInfo } from '@tencent/wphk-components-multi-jump-container';
import { FitButton } from '@tencent/wphk-ui';
import { onBeforeMount, ref, Ref } from 'vue';

/** bi埋点拓展参数 */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { getBiExt } = useGlobalBi();

/** 跳转信息 */
const jumpInfo: Ref<MultiJumpInfo | null> = ref(null);

/** 获取跳转信息方法 */
const getJumpInfo = async () => {
  const merchantId = getUrlParamByKey(UrlParamKey.spId) || getUrlParamByKey('merchantId' as any);
  const jumpInfo = await getJumpInfoFromRemoteConfig(merchantId);
  return jumpInfo;
};

onBeforeMount(async () => {
  showLoading();
  const [jumpInfoErr, jumpInfoConfig] = await to(getJumpInfo());

  if (jumpInfoErr) {
    hideLoading();
    new CustomException(jumpInfoErr, 'getJumpConfigFailed', '获取中转页配置失败');
    return jumpPage.goDiscountCenter({
      adtag: 'merhcantChannelThirdMp',
    });
  }
  hideLoading();
  jumpInfo.value = jumpInfoConfig;
});


return { __sfc: true,getBiExt, jumpInfo, getJumpInfo, MultiJumpContainer, FitButton }
}

})